import { Tooltip, type TooltipProps } from '@mui/material';

export type HFTooltipProps = TooltipProps;

/** Hover on desktop; tap-and-hold / tap on touch (enterTouchDelay 0). */
export function HFTooltip({ enterTouchDelay = 0, leaveTouchDelay = 2500, ...props }: HFTooltipProps) {
  return <Tooltip {...props} enterTouchDelay={enterTouchDelay} leaveTouchDelay={leaveTouchDelay} />;
}
